/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato di una comunicazione in coda
 */
export enum ComunicazioneOutboxStato {

    PENDENTE = 'PENDENTE',

    IN_CORSO = 'IN_CORSO',

    INVIATA = 'INVIATA',

    FALLITA_DEFINITIVA = 'FALLITA_DEFINITIVA',

    SALTATA_NO_RECAPITO = 'SALTATA_NO_RECAPITO'
}

